import {twMerge} from "tailwind-merge";

export default function RadioButton({title = "", options = [], name = "", classes = {}, active = "", ...otherProps}) {

    const {parentClasses = "", titleClasses = "", labelClasses = "", activeClasses = "", activeIconClasses = ""} = classes;

    return (
        <div className={twMerge("space-y-2.5", parentClasses)}>
            <p className={twMerge("text-pol-gray text-sm mr-4", titleClasses)}>{title}</p>
            {
                options.map(item => (
                    <label key={item.value}
                           className={twMerge(`flex items-center border rounded-[0.875rem] px-2.5 py-4 cursor-pointer ${active === item.value ? twMerge("bg-pol-light-orange-2 border-pol-main-dark-color", activeClasses) : "border-pol-light-purple-2"}`, labelClasses)}>
                        <input type="radio"
                               className="peer hidden"
                               name={name}
                               value={item.value}
                               {...otherProps}/>
                        <div
                            className={`w-5 h-5 min-w-[1.25rem] ml-2.5 rounded-[0.313rem] flex-center ${active === item.value ? twMerge("bg-white text-pol-main-dark-color", activeIconClasses) : "bg-pol-light-5"}`}>
                            {
                                active === item.value ? <i className="icon-tick text-xs" /> : null
                            }
                        </div>
                        <div className={active === item.value ? "text-pol-dark" : "text-pol-purple"}>
                            {item.text}
                        </div>
                    </label>
                ))
            }
        </div>
    )
}
